import { EmptyTableResults } from '@/components/Table/styles';
import { OPCO_ORGANIZATIONS_TABLE_CONFIG } from '../const/const';
import { TableType } from '@/components/Table/types/types';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { getOpcoOrganizationUsersPath } from '@/bundle/_Opco/ui/OrganizationDetails/path/path';
import { OrganizationListItemType } from '@/api/v1/opco/organizations/getOrganizationsApi';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { NoResults } from '@/components/NoResults/NoResults';
import NoItemsIcon from '@/images/NoItemsIcon.svg?react';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const OpcoOrganizationsTable = ({ items = [], isLoading }: TableType<OrganizationListItemType>) => {
  const { isMobile } = useResponsiveDevice();
  const { navigateFrom } = useStatefulNavigation();

  const hasItems = !!items.length;
  const noItems = !hasItems && !isLoading;

  const navigateToUsers = (item: OrganizationListItemType) => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.OrganizationUsersListRedirect);

    navigateFrom(getOpcoOrganizationUsersPath(item.id));
  };

  if (noItems) {
    return (
      <EmptyTableResults>
        <NoResults icon={<NoItemsIcon />} message='Please create your first organization.' />
      </EmptyTableResults>
    );
  }

  return (
    <>
      {isMobile ? (
        <MobileTable
          config={OPCO_ORGANIZATIONS_TABLE_CONFIG}
          items={items}
          isLoading={isLoading}
          onRowClick={navigateToUsers}
        />
      ) : (
        <DesktopTable
          config={OPCO_ORGANIZATIONS_TABLE_CONFIG}
          items={items}
          isLoading={isLoading}
          onRowClick={navigateToUsers}
        />
      )}
    </>
  );
};
